export const GET_ATTENDANCE_REQ = "GET_ATTENDANCE_REQ";
export const GET_ATTENDANCE_SUCCESS = "GET_ATTENDANCE_SUCCESS";
export const GET_ATTENDANCE_FAILED = "GET_ATTENDANCE_FAILED";

export const CREATE_ATTENDANCE_REQ = "CREATE_ATTENDANCE_REQ";
export const CREATE_ATTENDANCE_SUCCESS = "CREATE_ATTENDANCE_SUCCESS";
export const CREATE_ATTENDANCE_FAILED = "CREATE_ATTENDANCE_FAILED";
export const CREATE_ATTENDANCE_RESET = "CREATE_ATTENDANCE_RESET";

export const JOIN_CLASS_REQ = "JOIN_CLASS_REQ";
export const JOIN_CLASS_SUCCESS = "JOIN_CLASS_SUCCESS";
export const JOIN_CLASS_FAILED = "JOIN_CLASS_FAILED";
export const JOIN_CLASS_RESET = "JOIN_CLASS_RESET";
